import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, provideDefaultConfig } from '@spartacus/core';
import { AlertMessageModule } from '../../../../shared/components/alert-message';
import { SalesOrgAlertMessageComponent } from './sales-org-alert-message.component';

@NgModule({
  imports: [CommonModule, AlertMessageModule],
  declarations: [SalesOrgAlertMessageComponent],
  exports: [SalesOrgAlertMessageComponent],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        SalesOrgAlertMessageComponent: {
          component: SalesOrgAlertMessageComponent,
        },
      },
    }),
  ],
})
export class SalesOrgAlertMessageModule {}
